import React, { useState, useEffect } from 'react';
import { styles as s } from '../styles';

export const About = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section id="about" style={{ ...s.aboutSection, overflow: 'hidden' }}>
      <div style={s.aboutContainer}>

        <p style={{ ...s.aboutQuote, marginBottom: isMobile ? '40px' : '80px' }}>
          "I'm here to help bring YOUR Italian voice to life, one lesson at a time."
        </p>

        <div style={{
          ...wrappingContainer,
          display: isMobile ? 'flex' : 'block',
          flexDirection: 'column',
          alignItems: 'center',
        }}>

          <div style={{
            ...photoContainer,
            float:        isMobile ? 'none' : 'left',
            width:        isMobile ? '200px' : '280px',
            marginLeft:   isMobile ? '0' : '-10px',
            marginRight:  isMobile ? '0' : '50px',
            marginBottom: isMobile ? '32px' : '20px',
          }}>
{false ? (
              <div style={{ ...photoStyle, height: '320px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F7F4EF', gap: '12px' }}>
<div style={{ width: '80px', height: '80px', borderRadius: '50%', backgroundColor: 'rgba(188,108,37,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="8" r="4" fill="#BC6C25" opacity="0.5"/>
                    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" fill="#BC6C25" opacity="0.5"/>
                  </svg>
                </div>
                <p style={{ margin: 0, fontSize: '0.75rem', fontWeight: 700, color: '#BC6C25', textTransform: 'uppercase', letterSpacing: '2px', textAlign: 'center' }}>
                  Photo coming soon
                </p>
              </div>
            ) : (
              <img src="/francesca1.jpg" alt="Francesca" style={photoStyle} />
            )}          </div>

          <p style={s.aboutParagraph}>
            I know that <strong style={{ fontWeight: 600 }}>split-second hesitation</strong> before you speak,
            the mental translation that slows you down, and that feeling of wanting to say
            so much more than your vocabulary allows.
          </p>

          <p style={s.aboutParagraph}>
            After <strong style={{ color: '#BC6C25', fontWeight: 600 }}>more than 2,500 lessons</strong>,
            I've realized that <strong>learning a language is a deeply personal journey.</strong> No two paths look quite the same.
          </p>

          <p style={s.aboutParagraph}>
            There is absolutely no pressure here. Unlike a group class,
            we <strong style={{ fontWeight: 600 }}>move at your speed</strong>.
            From wherever you are in the world, we focus on building
            a language that <span style={{ color: '#BC6C25', fontWeight: 600 }}>actually sounds like you.</span>
          </p>

          <p style={s.aboutParagraph}>
            We'll build your Italian <strong style={{ fontWeight: 600 }}>one conversation at a time</strong>,
            exactly where you are today.
          </p>

          <div style={{ clear: 'none', marginTop: '50px', textAlign: isMobile ? 'center' : 'center' }}>
            <h3 style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(1.5rem, 4vw, 1.8rem)',
              fontWeight: 400,
              fontStyle: 'italic',
              color: '#283618',
              margin: 0,
              lineHeight: 1.2,
              letterSpacing: '1px',
            }}>
              Say <span style={{ color: '#BC6C25', fontWeight: 600, fontStyle: 'normal' }}>Ciao</span> to your own Italian voice!
            </h3>
          </div>

        </div>
      </div>
    </section>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const wrappingContainer = {
  maxWidth: '1000px',
  margin: '0 auto',
  textAlign: 'left',
  position: 'relative',
};

const photoContainer = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '280px',
  shapeOutside: 'inset(0% 0% 0% 0% round 15px)',
};

const photoStyle = {
  width: '100%',
  borderRadius: '15px',
  objectFit: 'cover',
  objectPosition: 'center top',
  padding: '8px',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  border: '1px solid rgba(188, 108, 37, 0.08)',
  boxShadow: '0 15px 35px rgba(40, 54, 24, 0.05)',
};